import { useTranslation } from 'react-i18next';
import styles from './gift-card.module.scss';
import Image from '@components/elements/image/image';
import Button from '@components/elements/button/button';

interface GiftCardProps {
  title: string;
  image: string | null;
  onAdd?: () => void;
}

const GiftCard: React.FC<React.PropsWithChildren<GiftCardProps>> = (props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          className={styles.image}
          src={props.image}
          alt={props.title}
          layout="fill"
          objectFit="cover"
          priority={false}
          loading="lazy"
          onClick={() => props.onAdd?.()}
        />
      </div>
      <div className={styles.details}>
        <h3 className={styles.title}>{props.title}</h3>
        <div className={styles.controls}>
          <Button
            size="medium"
            symmetrical={false}
            className={styles.addButton}
            onClick={() => props.onAdd?.()}
          >
            <span className={styles.buttonText}>
              {t('gift_card_configurator.add')}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GiftCard;
